import { OrderExcelUploadItem } from '../../../types/multiChannel';
import { MultiChannelOrderItemBulkInsertRequestDto } from '../../../types/api/multi-channels';

export const convertOrderListToOrderCreateInput = (
  orderList: OrderExcelUploadItem[],
): MultiChannelOrderItemBulkInsertRequestDto => {
  return {
    multiChannelOrderItems: orderList.map((item) => ({
      brandId: Number(item.brandId.value),
      brandName: String(item.brandName.value),
      productId: Number(item.productId.value),
      productOptionId: Number(item.productOptionId.value),
      productName: String(item.productName.value),
      productBarcode: String(item.productBarcode.value),
      productNumber: String(item.productNumber.value),
      productOptionName: String(item.productOptionName.value),
      productOptionBarcode: String(item.productOptionBarcode.value),
      productOptionNumber: String(item.productOptionNumber.value),
      multiChannelId: Number(item.multiChannelId.value),
      multiChannelName: String(item.multiChannelName.value),
      externalOrderId: String(item.externalOrderId.value),
      quantity: Number(item.quantity.value),
      message: String(item.message.value),
      recipient: String(item.recipient.value),
      cellPhone: String(item.cellPhone.value),
      address: String(item.address.value),
      addressDetail: String(item.addressDetail.value),
      postCode: String(item.postCode.value),
    })),
  };
};
